import { render, staticRenderFns } from "./NewShipment.vue?vue&type=template&id=ee8485f4&"
import script from "./NewShipment.vue?vue&type=script&lang=ts&"
export * from "./NewShipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports